/*
 Convention: https://docs.google.com/document/d/1ePqfM41II2CNBYpTuOgjLZafRkn6vABQ5NF40JGER1E/edit
 Review Reference: https://docs.google.com/document/d/1Diu8ZwKXPOWCsH2ry8rufCYADGFcHtR4MY3k1c3Ypes/edit

 ! Review
 TODO Disbursement - Remove all redux, use SWR instead
 */

import update from 'immutability-helper';
import { ActionType, defaultAction } from 'src/redux/types';
import {
  BalanceDetail,
  CashInDetail,
  CashOutDetail,
  TxDetails,
  TxSummary,
} from '../types';
import { ACTION_TYPES } from './types';

export type TxDetailsState = {
  data: TxDetails[];
  isLoading: boolean;
  error: string;
  isSuccess: boolean;
};

export type BalanceDetailState = {
  data: BalanceDetail;
  isLoading: boolean;
  error: string;
  isSuccess: boolean;
};

export type TxSummaryState = {
  data: TxSummary[];
  isLoading: boolean;
  error: string;
  total: number;
  isSuccess: boolean;
};

export type CashInDetailState = {
  data: CashInDetail[];
  isLoading: boolean;
  error: string;
  total: number;
  isSuccess: boolean;
};

export type CashOutDetailState = {
  data: CashOutDetail[];
  isLoading: boolean;
  error: string;
  total: number;
  isSuccess: boolean;
};

export type BridgedState = {
  txDetails: TxDetailsState;
  txSummary: TxSummaryState;
  balanceDetail: BalanceDetailState;
  cashInDetail: CashInDetailState;
  cashOutDetail: CashOutDetailState;
};

const initialState: BridgedState = {
  txSummary: {
    data: [],
    isLoading: false,
    error: '',
    total: 0,
    isSuccess: false,
  },
  cashInDetail: {
    data: [],
    isLoading: false,
    error: '',
    total: 0,
    isSuccess: false,
  },
  cashOutDetail: {
    data: [],
    isLoading: false,
    error: '',
    total: 0,
    isSuccess: false,
  },
  txDetails: {
    data: [],
    isLoading: false,
    error: '',
    isSuccess: false,
  },
  balanceDetail: {
    data: {
      lastUpdated: '',
      availableBalance: 0,
      totalUsedBalance: 0,
      totalToBePaid: 0,
    },
    isLoading: false,
    error: '',
    isSuccess: false,
  },
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;
  switch (type) {
    case ACTION_TYPES.BRIDGED_BALANCE_DETAIL:
      return update(state, {
        balanceDetail: {
          isLoading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.BRIDGED_BALANCE_DETAIL_SUCCESS:
      return update(state, {
        balanceDetail: {
          $merge: {
            data: payload.data,
            isLoading: false,
            isSuccess: true,
          },
        },
      });
    case ACTION_TYPES.BRIDGED_BALANCE_DETAIL_FAILED:
      return update(state, {
        balanceDetail: {
          $merge: {
            isLoading: false,
            isSuccess: false,
          },
        },
      });
    case ACTION_TYPES.BRIDGED_TX_DETAILS_LIST:
      return update(state, {
        txDetails: {
          isLoading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.BRIDGED_TX_DETAILS_LIST_SUCCESS:
      return update(state, {
        txDetails: {
          $merge: {
            data: payload.data,
            isLoading: false,
            isSuccess: true,
          },
        },
      });
    case ACTION_TYPES.BRIDGED_TX_DETAILS_LIST_FAILED:
      return update(state, {
        txDetails: {
          $merge: {
            isLoading: false,
            isSuccess: false,
          },
        },
      });
    case ACTION_TYPES.BRIDGED_TX_SUMMARY_LIST:
      return update(state, {
        txSummary: {
          isLoading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.BRIDGED_TX_SUMMARY_LIST_SUCCESS:
      return update(state, {
        txSummary: {
          $merge: {
            data: payload.data.data,
            total: payload.data.total,
            isLoading: false,
            isSuccess: true,
          },
        },
      });
    case ACTION_TYPES.BRIDGED_TX_SUMMARY_LIST_FAILED:
      return update(state, {
        txSummary: {
          $merge: {
            isLoading: false,
            isSuccess: false,
          },
        },
      });
    case ACTION_TYPES.BRIDGED_CASH_IN_LIST:
      return update(state, {
        cashInDetail: {
          isLoading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.BRIDGED_CASH_IN_LIST_SUCCESS:
      return update(state, {
        cashInDetail: {
          $merge: {
            data: payload.data.data,
            total: payload.data.total,
            isLoading: false,
            isSuccess: true,
          },
        },
      });
    case ACTION_TYPES.BRIDGED_CASH_IN_LIST_FAILED:
      return update(state, {
        cashInDetail: {
          $merge: {
            isLoading: false,
            isSuccess: false,
          },
        },
      });
    case ACTION_TYPES.BRIDGED_CASH_OUT_LIST:
      return update(state, {
        cashOutDetail: {
          isLoading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.BRIDGED_CASH_OUT_LIST_SUCCESS:
      return update(state, {
        cashOutDetail: {
          $merge: {
            data: payload.data.data,
            total: payload.data.total,
            isLoading: false,
            isSuccess: true,
          },
        },
      });
    case ACTION_TYPES.BRIDGED_CASH_OUT_LIST_FAILED:
      return update(state, {
        cashOutDetail: {
          $merge: {
            isLoading: false,
            isSuccess: false,
          },
        },
      });
    default:
      return state;
  }
};
